export default __webpack_public_path__ + "static/media/create_your_own_canvas.460f6263.png";